import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=2511625c&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2511625c&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ros-kepler-tecowebsite(r项目开发者平台)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2511625c"]])

export default __exports__